import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initSentry } from './config/sentry'
import { logger, setLogLevel } from '@/lib/logging'
import { startVersionCheck } from '@/lib/version-check'
import { toast } from 'sonner'

// Direct console log for debugging
console.log('Pre-initialization check');

// Initialize Sentry as early as possible
initSentry();

// Initialize logging with maximum verbosity
console.log('Setting maximum log verbosity for debugging');
setLogLevel('trace');
logger.trace('🔍 TRACE level logging is enabled');
logger.debug('🐞 DEBUG level logging is enabled');
logger.info('🚀 Application starting...');
logger.warn('⚠️ WARN level logging is enabled');

// Log environment details
logger.info('Environment details:', {
  mode: import.meta.env.MODE,
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
  apiUrl: import.meta.env.VITE_API_URL,
  hasClerkKey: !!import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  hasSentry: !!import.meta.env.VITE_SENTRY_DSN
});

// Log window.location for debugging deployment
logger.info('Current location:', {
  href: window.location.href,
  hostname: window.location.hostname,
  pathname: window.location.pathname
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

startVersionCheck();

// A lazily imported chunk from an older deploy is gone after a new deploy;
// reload once to pick up the current build instead of leaving a broken screen.
window.addEventListener('vite:preloadError', () => {
  const last = Number(sessionStorage.getItem('verifai_chunk_reload') || 0);
  if (Date.now() - last < 30_000) {
    // Already reloaded moments ago; don't loop, but leave the user a way out.
    toast.error('Part of the app failed to load', {
      description: 'Reload the page to try again.',
      duration: Infinity,
      action: { label: 'Reload', onClick: () => window.location.reload() },
    });
    return;
  }
  sessionStorage.setItem('verifai_chunk_reload', String(Date.now()));
  window.location.reload();
});
